import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryByAxios } from "@/redux/api/fetchBaseQueryHelper";

export const productApi = createApi({
	reducerPath: "product",
	baseQuery: fetchBaseQueryByAxios,
	endpoints: (builder) => ({
		getProductList: builder.query({
			query: () => `/product/allProducts`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		deleteProduct: builder.mutation({
			query(id) {
				return {
					url: `/product/productById?product_id=${id}`,
					method: "DELETE",
				};
			},
		}),
		addProduct: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/product/newProduct",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		updateProduct: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/product/productById",
					method: "PUT",
					body: initialPost,
				};
			},
		}),
	}),
});

export const {
	useGetProductListQuery,
	useAddProductMutation,
	useDeleteProductMutation,
	useUpdateProductMutation,
} = productApi;
